module.exports = "/images/pi-point.svg?edeee1b882f66a57be56a6c82fea01e8";